import React from "react";
import { Link, useLocation } from "react-router-dom";
import swanLogo from "../../assets/branding/swan-logo.png";

export default function Banner() {
    const location = useLocation();
    const isAuthRoute = ["/", "/entry", "/login", "/verify-code", "/auth-status", "/portal-selection"]
        .some((pathname) => location.pathname.startsWith(pathname));
    const isReferrerPortal = location.pathname.startsWith("/referrer");
    const logoTarget = isAuthRoute ? "/entry" : isReferrerPortal ? "/referrer/dashboard" : "/dashboard";

    return (
        <div className="w-full flex justify-center py-4">
            <Link to={logoTarget} aria-label="Financial Edge AX secure access home">
                <img
                    src={swanLogo}
                    alt="Financial Edge AX green swan"
                    className="h-[56px] md:h-[68px] object-contain cursor-pointer"
                />
            </Link>
        </div>
    );
}
